import * as NUMBERS from 'constant/number'
import { connect } from 'react-redux'
import { Form, Select, Card } from 'antd'
import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { getAllSites } from 'action/site'
import PropTypes from 'prop-types'
import './styles.scss'

const SitesUserTypeSelect = ({ sites, userTypes, loading, getAllSites, disabled = false }) => {
  useEffect(() => getAllSites(), [])

  return (
    <Form.Item
      id='userTypeForm'
      label='Site Assignment'
    >
      <Card
        bordered={false}
        loading={loading}
        style={{ 'border-radius': '4px' }}
      >
        {sites.map(({ site_name: siteName, uuid }) => (
          <Form.Item
            key={uuid}
            label={siteName}
            name={siteName}
          >
            <Select
              allowClear
              placeholder='No access'
            >
              {userTypes.map(({ name, uuid: userUuid }) => {
                return (name !== 'no access' && <>
                  <Select.Option
                    bordered={false}
                    key={`${uuid}-${userUuid}`}
                    value={userUuid}
                  >{name.charAt(NUMBERS.ZERO).toUpperCase() + name.slice(NUMBERS.ONE)}
                  </Select.Option>
                </>)
              })}
            </Select>
          </Form.Item>
        ))}
      </Card>
    </Form.Item>
  )
}

SitesUserTypeSelect.propTypes = {
  disabled: PropTypes.bool,
  getAllSites: PropTypes.func,
  loading: PropTypes.bool,
  required: PropTypes.bool,
  sites: PropTypes.array,
  userTypes: PropTypes.array
}

const mapStateToProps = (state) => ({
  loading: state.loader.loading,
  sites: state.site.allSites,
  userTypes: state.user.userTypes
})

const mapDispatchToProps = (dispatch) => ({
  getAllSites: bindActionCreators(getAllSites, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SitesUserTypeSelect)
